(function () {
  'use strict';

  var DEFAULTS = {
    shape: 1,
    softness: 0.84,
    intensity: 0.18,
    noise: 0.18,
    /* Grain frequency, not amount: grain_uv is multiplied by this, so a higher
       value means more cycles across the same pixels — finer, tighter grain.
       Was a hardcoded 0.7. Per-element via data-grain-scale. */
    grainScale: 3.4,
    speed: 0.94,
    scale: 2.58,
    rotation: 0,
    offsetX: 0,
    offsetY: -0.25,
    band: 0.055,
    colorBack: '#00000000',
    colors: ['#fb6c25', '#FF7A3C', '#E03F29', '#ca2a1c'],
  };

  /* Per-product fallbacks when data-color-back is missing from metafields.
     The shader composites u_colorBack into transparent bands, so a leftover
     Annapurna red here shows up on yellow/green bottles. */
  var PRODUCT_GRAD = {
    annapurna: {
      shape: 1, softness: 0.84, intensity: 0.16, noise: 0, speed: 0.94,
      scale: 2, rotation: 0, offsetX: 0, offsetY: -0.25, band: 0.015,
      colorBack: '#E8481F',
      colors: ['#ff6600', '#ff9d2e', '#ff4b0f', '#ee4d3f'],
    },
    kilimanjaro: {
      shape: 1, softness: 0.84, intensity: 0.16, noise: 0, speed: 0.94,
      scale: 2, rotation: 0, offsetX: 0, offsetY: -0.25, band: 0.055,
      colorBack: '#ffee8f',
      colors: ['#fff833', '#ffa114', '#ecda89', '#f77902', '#FFD901'],
    },
    huangshan: {
      shape: 1, softness: 0.84, intensity: 0.16, noise: 0, speed: 0.94,
      scale: 2, rotation: 0, offsetX: 0, offsetY: -0.25, band: 0.015,
      colorBack: '#73B34F',
      colors: ['#f7ffcc', '#B7CF61', '#c9dea0', '#73D160', '#2EA34B'],
    },
  };

  var GG_VERT = '#version 300 es\nin vec2 p;out vec2 vUv;void main(){vUv=p*0.5+0.5;gl_Position=vec4(p,0.,1.);}';
  var GG_FRAG = '#version 300 es\nprecision highp float;\nin vec2 vUv; out vec4 fragColor;\nuniform float u_time,u_softness,u_intensity,u_noise,u_shape,u_scale,u_rotation,u_grainScale;\nuniform float u_offsetX,u_offsetY,u_band,u_colorsCount,u_edgeVertical;\nuniform vec2 u_resolution;\nuniform vec4 u_colorBack;\nuniform vec4 u_colors[7];\n#define TWO_PI 6.28318530718\n#define PI 3.14159265358979323846\nvec2 rotate(vec2 uv,float th){return mat2(cos(th),sin(th),-sin(th),cos(th))*uv;}\nfloat hash11(float p){p=fract(p*0.3183099)+0.1;p*=p+19.19;return fract(p*p);}\nfloat randomR(vec2 p){p=floor(p);p=fract(p*vec2(0.3183099,0.3678794))+0.1;p+=dot(p,p+19.19);return fract(p.x*p.y);}\nvec3 permute(vec3 x){return mod(((x*34.0)+1.0)*x,289.0);}\nfloat snoise(vec2 v){\n  const vec4 C=vec4(0.211324865405187,0.366025403784439,-0.577350269189626,0.024390243902439);\n  vec2 i=floor(v+dot(v,C.yy)); vec2 x0=v-i+dot(i,C.xx);\n  vec2 i1=(x0.x>x0.y)?vec2(1.0,0.0):vec2(0.0,1.0);\n  vec4 x12=x0.xyxy+C.xxzz; x12.xy-=i1; i=mod(i,289.0);\n  vec3 p=permute(permute(i.y+vec3(0.0,i1.y,1.0))+i.x+vec3(0.0,i1.x,1.0));\n  vec3 m=max(0.5-vec3(dot(x0,x0),dot(x12.xy,x12.xy),dot(x12.zw,x12.zw)),0.0);\n  m=m*m;m=m*m;\n  vec3 x=2.0*fract(p*C.www)-1.0; vec3 h=abs(x)-0.5; vec3 ox=floor(x+0.5); vec3 a0=x-ox;\n  m*=1.79284291400159-0.85373472095314*(a0*a0+h*h);\n  vec3 g; g.x=a0.x*x0.x+h.x*x0.y; g.yz=a0.yz*x12.xz+h.yz*x12.yw;\n  return 130.0*dot(m,g);\n}\nfloat valueNoiseR(vec2 st){\n  vec2 i=floor(st),f=fract(st);\n  float a=randomR(i),b=randomR(i+vec2(1.,0.)),c=randomR(i+vec2(0.,1.)),d=randomR(i+vec2(1.,1.));\n  vec2 u=f*f*(3.0-2.0*f);\n  return mix(mix(a,b,u.x),mix(c,d,u.x),u.y);\n}\nvec4 fbmR(vec2 n0,vec2 n1,vec2 n2,vec2 n3){\n  float amplitude=0.2; vec4 total=vec4(0.);\n  for(int i=0;i<3;i++){\n    n0=rotate(n0,0.3);n1=rotate(n1,0.3);n2=rotate(n2,0.3);n3=rotate(n3,0.3);\n    total.x+=valueNoiseR(n0)*amplitude; total.y+=valueNoiseR(n1)*amplitude;\n    total.z+=valueNoiseR(n2)*amplitude; total.z+=valueNoiseR(n3)*amplitude;\n    n0*=1.99;n1*=1.99;n2*=1.99;n3*=1.99; amplitude*=0.6;\n  }\n  return total;\n}\nvec2 truchet(vec2 uv,float idx){\n  idx=fract(((idx-.5)*2.));\n  if(idx>0.75){uv=vec2(1.0)-uv;}\n  else if(idx>0.5){uv=vec2(1.0-uv.x,uv.y);}\n  else if(idx>0.25){uv=1.0-vec2(1.0-uv.x,uv.y);}\n  return uv;\n}\nvoid main(){\n  const float firstFrameOffset=7.;\n  float t=.1*(u_time+firstFrameOffset);\n  float aspect=u_resolution.x/max(u_resolution.y,1.);\n  float r=u_rotation*PI/180.;\n  mat2 rot=mat2(cos(r),sin(r),-sin(r),cos(r));\n  vec2 objectUV=(vUv-0.5)*2.0*vec2(aspect,1.0);\n  objectUV=rot*objectUV;\n  objectUV/=max(u_scale,0.01);\n  objectUV-=vec2(-u_offsetX,u_offsetY);\n  vec2 shape_uv=objectUV;\n  vec2 grain_uv=objectUV*u_resolution*u_grainScale;\n  float shape=0.;\n  if(u_shape<1.5){\n    float wave=cos(.5*shape_uv.x-4.*t)*sin(1.5*shape_uv.x+2.*t)*(.75+.25*cos(6.*t));\n    shape=1.-smoothstep(-1.,1.,shape_uv.y+wave);\n  } else if(u_shape<2.5){\n    float stripeIdx=floor(2.*shape_uv.x/TWO_PI);\n    float rnd=hash11(stripeIdx*100.);\n    rnd=sign(rnd-.5)*pow(4.*abs(rnd),.3);\n    shape=sin(shape_uv.x)*cos(shape_uv.y-5.*rnd*t);\n    shape=pow(abs(shape),4.);\n  } else if(u_shape<3.5){\n    float n2=valueNoiseR(shape_uv*.4-3.75*t);\n    shape_uv.x+=10.; shape_uv*=.6;\n    vec2 tile=truchet(fract(shape_uv),randomR(floor(shape_uv)));\n    float d1=length(tile), d2=length(tile-vec2(1.));\n    n2-=.5; n2*=.1;\n    shape=smoothstep(.2,.55,d1+n2)*(1.-smoothstep(.45,.8,d1-n2));\n    shape+=smoothstep(.2,.55,d2+n2)*(1.-smoothstep(.45,.8,d2-n2));\n    shape=pow(shape,1.5);\n  } else if(u_shape<4.5){\n    shape_uv*=.6; vec2 outer=vec2(.5);\n    vec2 bl=smoothstep(vec2(0.),outer,shape_uv+vec2(.1+.1*sin(3.*t),.2-.1*sin(5.25*t)));\n    vec2 tr=smoothstep(vec2(0.),outer,1.-shape_uv);\n    shape=1.-bl.x*bl.y*tr.x*tr.y;\n    shape_uv=-shape_uv;\n    bl=smoothstep(vec2(0.),outer,shape_uv+vec2(.1+.1*sin(3.*t),.2-.1*cos(5.25*t)));\n    tr=smoothstep(vec2(0.),outer,1.-shape_uv);\n    shape-=bl.x*bl.y*tr.x*tr.y;\n    shape=1.-smoothstep(0.,1.,shape);\n  } else if(u_shape<5.5){\n    shape_uv*=2.;\n    float dist=length(.4*shape_uv);\n    shape=sin(pow(dist,1.2)*5.-3.*t)*.5+.5;\n  } else if(u_shape<6.5){\n    t*=2.;\n    vec2 f1=.25*vec2(1.3*sin(t),.2+1.3*cos(.6*t+4.));\n    vec2 f2=.2*vec2(1.2*sin(-t),1.3*sin(1.6*t));\n    vec2 f3=.25*vec2(1.7*cos(-.6*t),cos(-1.6*t));\n    vec2 f4=.3*vec2(1.4*cos(.8*t),1.2*sin(-.6*t-3.));\n    shape =.5*pow(1.-clamp(length(shape_uv+f1),0.,1.),5.);\n    shape+=.5*pow(1.-clamp(length(shape_uv+f2),0.,1.),5.);\n    shape+=.5*pow(1.-clamp(length(shape_uv+f3),0.,1.),5.);\n    shape+=.5*pow(1.-clamp(length(shape_uv+f4),0.,1.),5.);\n    shape=smoothstep(.0,.9,shape);\n    float edge=smoothstep(.25,.3,shape);\n    shape=mix(.0,shape,edge);\n  } else {\n    shape_uv*=2.;\n    float d=1.-pow(length(shape_uv),2.);\n    vec3 pos=vec3(shape_uv,sqrt(max(d,0.)));\n    vec3 lightPos=normalize(vec3(cos(1.5*t),.8,sin(1.25*t)));\n    shape=.5+.5*dot(lightPos,pos);\n    shape*=step(0.,d);\n  }\n  float baseNoise=snoise(grain_uv*.5);\n  vec4 fbmVals=fbmR(.002*grain_uv+10., .003*grain_uv, .001*grain_uv, rotate(.4*grain_uv,2.));\n  float grainDist=baseNoise*snoise(grain_uv*.2)-fbmVals.x-fbmVals.y;\n  float rawNoise=.75*baseNoise-fbmVals.w-fbmVals.z;\n  float noise=clamp(rawNoise,0.,1.);\n  shape+=u_intensity*2./u_colorsCount*(grainDist+.5);\n  shape+=u_noise*10./u_colorsCount*noise;\n  float aa=fwidth(shape);\n  shape=clamp(shape-.5/u_colorsCount,0.,1.);\n  float totalShape=smoothstep(0.,u_softness+2.*aa,clamp(shape*u_colorsCount,0.,1.));\n  float mixer=shape*(u_colorsCount-1.);\n  int cntStop=int(u_colorsCount)-1;\n  vec4 gradient=u_colors[0]; gradient.rgb*=gradient.a;\n  for(int i=1;i<7;i++){\n    if(i>cntStop) break;\n    float localT=clamp(mixer-float(i-1),0.,1.);\n    localT=smoothstep(.5-.5*u_softness-aa,.5+.5*u_softness+aa,localT);\n    vec4 c=u_colors[i]; c.rgb*=c.a;\n    gradient=mix(gradient,c,localT);\n  }\n  vec3 color=gradient.rgb*totalShape;\n  float opacity=gradient.a*totalShape;\n  vec3 bg=u_colorBack.rgb*u_colorBack.a;\n  color=color+bg*(1.0-opacity);\n  opacity=opacity+u_colorBack.a*(1.0-opacity);\n  float edgeCoord=u_edgeVertical>1.5?vUv.y:(u_edgeVertical>0.5?(1.0-vUv.y):vUv.x);\n  float edgeT=smoothstep(0.,max(u_band,0.001),edgeCoord);\n  float dth=randomR(gl_FragCoord.xy*3.17+vec2(7.,3.));\n  opacity*=step(dth*0.98,edgeT);\n  fragColor=vec4(color,opacity);\n}';

  var UNIFORM_NAMES = [
    'u_time', 'u_softness', 'u_intensity', 'u_noise', 'u_shape', 'u_scale', 'u_rotation', 'u_grainScale',
    'u_offsetX', 'u_offsetY', 'u_band', 'u_colorsCount', 'u_edgeVertical', 'u_resolution', 'u_colorBack', 'u_colors',
  ];

  /* Grain depends only on pixel position and size/scale/rotation/offset/grainScale, never u_time: bake it once, cut from GG_FRAG so the noise code stays single-source. */
  var GG_FRAG_BAKED = null;
  var GG_FRAG_GRAIN = null;
  (function () {
    var startTok = 'float baseNoise=snoise(grain_uv*.5);';
    var endTok = 'float noise=clamp(rawNoise,0.,1.);';
    var resTok = 'uniform vec2 u_resolution;';
    var s = GG_FRAG.indexOf(startTok);
    var e = GG_FRAG.indexOf(endTok);
    var m = GG_FRAG.indexOf('void main(){');
    var a = GG_FRAG.indexOf('float aspect=');
    var q = GG_FRAG.indexOf('float shape=0.;');
    if (s < 0 || e < s || m < 0 || a < m || q < a || q > s || GG_FRAG.indexOf(resTok) < 0) return;
    e += endTok.length;
    /* The bake viewport is padded to even size, so uv comes from gl_FragCoord/u_resolution (real size) instead of the varying. */
    var setup = GG_FRAG.slice(a, q).replace('(vUv-0.5)', '(gl_FragCoord.xy/u_resolution-0.5)');
    if (setup === GG_FRAG.slice(a, q)) return;
    GG_FRAG_GRAIN = GG_FRAG.slice(0, m) + 'void main(){\n  ' + setup + GG_FRAG.slice(s, e) +
      '\n  fragColor=vec4(grainDist,noise,0.,1.);\n}';
    GG_FRAG_BAKED = (GG_FRAG.slice(0, s) +
      'vec2 gn=texelFetch(u_grain,ivec2(gl_FragCoord.xy),0).rg;\n  float grainDist=gn.x;\n  float noise=gn.y;' +
      GG_FRAG.slice(e)).replace(resTok, resTok + '\nuniform highp sampler2D u_grain;');
  })();

  /* Shared with bg-shader. One-way 30fps cap after sustained slow frames; capable devices never hit it. */
  function createGovernor() {
    var WARMUP_MS = 3000;
    var WINDOW = 90;
    var SLOW_MS = 26;
    var STRIKES = 3;
    var CAP_GAP_MS = 30;
    var lastNow = 0;
    var lastRender = 0;
    var decision = true;
    var startedAt = 0;
    var dts = [];
    var strikes = 0;
    var capped = false;

    function restart() {
      lastNow = 0;
      startedAt = 0;
      dts.length = 0;
      strikes = 0;
    }

    document.addEventListener('visibilitychange', restart);

    return {
      frame: function (now) {
        if (now === lastNow) return decision;
        var dt = lastNow ? now - lastNow : 0;
        lastNow = now;
        if (dt > 500) {
          startedAt = 0;
          dts.length = 0;
          strikes = 0;
          dt = 0;
        }
        if (!capped) {
          if (!startedAt) startedAt = now;
          if (dt > 0 && now - startedAt > WARMUP_MS) {
            dts.push(dt);
            if (dts.length >= WINDOW) {
              dts.sort(function (x, y) { return x - y; });
              strikes = dts[WINDOW >> 1] > SLOW_MS ? strikes + 1 : 0;
              dts.length = 0;
              if (strikes >= STRIKES) capped = true;
            }
          }
          decision = true;
          return true;
        }
        if (now - lastRender >= CAP_GAP_MS) {
          lastRender = now;
          decision = true;
        } else {
          decision = false;
        }
        return decision;
      },
      isCapped: function () { return capped; },
    };
  }

  var Governor = window.PeakFrameGovernor || (window.PeakFrameGovernor = createGovernor());
  Governor.create = createGovernor;

  function hexToRgba(hex) {
    hex = hex.replace(/^#/, '');
    if (hex.length === 3 || hex.length === 4) {
      hex = hex.split('').map(function (c) { return c + c; }).join('');
    }
    if (hex.length === 6) hex += 'ff';
    return [
      parseInt(hex.slice(0, 2), 16) / 255,
      parseInt(hex.slice(2, 4), 16) / 255,
      parseInt(hex.slice(4, 6), 16) / 255,
      parseInt(hex.slice(6, 8), 16) / 255,
    ];
  }

  var NUMBER_ATTRS = [
    'shape', 'softness', 'intensity', 'noise', 'speed', 'scale',
    'rotation', 'offsetX', 'offsetY', 'band', 'grainScale',
  ];

  var EDGE_MAP = { left: 0, top: 1, bottom: 2 };

  function configFor(id) {
    return Object.assign({}, DEFAULTS, PRODUCT_GRAD[id] || {});
  }

  function parseColors(value) {
    return String(value).split(',').map(function (c) {
      c = c.trim();
      if (!c) return '';
      return c.charAt(0) === '#' ? c : '#' + c;
    }).filter(Boolean);
  }

  function parseEdge(el) {
    if (el.dataset.edge != null && el.dataset.edge !== '') {
      var named = EDGE_MAP[String(el.dataset.edge).toLowerCase()];
      if (named != null) return named;
      var fromName = parseFloat(el.dataset.edge);
      if (!isNaN(fromName)) return fromName;
    }
    if (el.dataset.edgeVertical != null && el.dataset.edgeVertical !== '') {
      var fromVertical = parseFloat(el.dataset.edgeVertical);
      if (!isNaN(fromVertical)) return fromVertical;
    }
    return null;
  }

  function configFromElement(el) {
    if (!el) return configFor('');
    var id = el.dataset.product || '';
    var preset = PRODUCT_GRAD[id];
    var next = configFor(id);
    NUMBER_ATTRS.forEach(function (key) {
      var raw = el.dataset[key];
      if (raw == null || raw === '') return;
      var num = parseFloat(raw);
      if (!isNaN(num)) next[key] = num;
    });
    var hasColorBack = el.dataset.colorBack != null && el.dataset.colorBack !== '';
    if (hasColorBack) next.colorBack = el.dataset.colorBack;
    if (el.dataset.colors) {
      var colors = parseColors(el.dataset.colors);
      if (colors.length) {
        next.colors = colors;
        if (!hasColorBack && !preset) next.colorBack = colors[colors.length - 1];
      }
    }
    var edge = parseEdge(el);
    if (edge != null) next.edgeVertical = edge;
    return next;
  }

  function create(canvas, options) {
    options = options || {};

    var gl = null;
    var prog = null;
    var progGrain = null;
    var uniforms = {};
    var grainUniforms = {};
    var config = Object.assign({}, DEFAULTS);
    var colorFlat = new Float32Array(28);
    var colorBack = new Float32Array(4);
    var colorsDirty = true;
    var grainTex = null;
    var grainFbo = null;
    var grainW = 0;
    var grainH = 0;
    var grainKey = '';
    var lastMeasure = -Infinity;
    var raf = 0;
    var t0 = 0;
    var glFailed = false;

    function compileShader(type, source) {
      var shader = gl.createShader(type);
      gl.shaderSource(shader, source);
      gl.compileShader(shader);
      if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        throw new Error(gl.getShaderInfoLog(shader));
      }
      return shader;
    }

    function initGL() {
      gl = canvas.getContext('webgl2', { alpha: true, antialias: false, premultipliedAlpha: false });
      if (!gl) return false;

      try {
        if (GG_FRAG_BAKED && (gl.getExtension('EXT_color_buffer_float') || gl.getExtension('EXT_color_buffer_half_float'))) {
          try {
            progGrain = buildProgram(GG_FRAG_GRAIN);
            prog = buildProgram(GG_FRAG_BAKED);
          } catch (err) {
            progGrain = null;
            prog = null;
          }
        }
        if (!prog) prog = buildProgram(GG_FRAG);
      } catch (err) {
        gl = null;
        return false;
      }

      gl.bindVertexArray(gl.createVertexArray());
      var buffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
      gl.enableVertexAttribArray(0);
      gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 0, 0);
      gl.enable(gl.BLEND);
      gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);

      UNIFORM_NAMES.forEach(function (name) {
        uniforms[name] = gl.getUniformLocation(prog, name);
      });

      if (progGrain) {
        ['u_resolution', 'u_grainScale', 'u_scale', 'u_rotation', 'u_offsetX', 'u_offsetY'].forEach(function (name) {
          grainUniforms[name] = gl.getUniformLocation(progGrain, name);
        });
        gl.useProgram(prog);
        gl.uniform1i(gl.getUniformLocation(prog, 'u_grain'), 0);
      }

      if ('ResizeObserver' in window) {
        new ResizeObserver(function () { lastMeasure = -Infinity; }).observe(canvas);
      }

      return true;
    }

    function buildProgram(fragSrc) {
      var p = gl.createProgram();
      gl.attachShader(p, compileShader(gl.VERTEX_SHADER, GG_VERT));
      gl.attachShader(p, compileShader(gl.FRAGMENT_SHADER, fragSrc));
      gl.bindAttribLocation(p, 0, 'p');
      gl.linkProgram(p);
      if (!gl.getProgramParameter(p, gl.LINK_STATUS)) {
        throw new Error(gl.getProgramInfoLog(p));
      }
      return p;
    }

    function ensureGrainTarget(w, h) {
      if (grainW === w && grainH === h) return true;
      if (!grainTex) {
        grainTex = gl.createTexture();
        grainFbo = gl.createFramebuffer();
      }
      gl.activeTexture(gl.TEXTURE0);
      gl.bindTexture(gl.TEXTURE_2D, grainTex);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RG16F, w, h, 0, gl.RG, gl.HALF_FLOAT, null);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.bindFramebuffer(gl.FRAMEBUFFER, grainFbo);
      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, grainTex, 0);
      var ok = gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE;
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      grainW = w;
      grainH = h;
      grainKey = '';
      return ok;
    }

    function bakeGrain(w, h) {
      var key = w + 'x' + h + '|' + config.scale + '|' + config.rotation + '|' + config.offsetX + '|' +
        config.offsetY + '|' + config.grainScale;
      if (key === grainKey) return true;
      /* Even padding: fwidth() at an odd edge reads a 2x2-quad helper pixel one step outside the canvas. */
      var bw = w + (w & 1);
      var bh = h + (h & 1);
      if (!ensureGrainTarget(bw, bh)) return false;
      gl.bindFramebuffer(gl.FRAMEBUFFER, grainFbo);
      gl.viewport(0, 0, bw, bh);
      gl.disable(gl.BLEND);
      gl.useProgram(progGrain);
      gl.uniform2f(grainUniforms.u_resolution, w, h);
      gl.uniform1f(grainUniforms.u_grainScale, config.grainScale);
      gl.uniform1f(grainUniforms.u_scale, config.scale);
      gl.uniform1f(grainUniforms.u_rotation, config.rotation);
      gl.uniform1f(grainUniforms.u_offsetX, config.offsetX);
      gl.uniform1f(grainUniforms.u_offsetY, config.offsetY);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
      gl.enable(gl.BLEND);
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      grainKey = key;
      return true;
    }

    /* Float target unusable on this GPU: go back to the original single-pass shader. */
    function fallBackToSinglePass() {
      progGrain = null;
      if (grainTex) {
        gl.deleteTexture(grainTex);
        gl.deleteFramebuffer(grainFbo);
        grainTex = null;
        grainFbo = null;
      }
      try {
        prog = buildProgram(GG_FRAG);
        UNIFORM_NAMES.forEach(function (name) {
          uniforms[name] = gl.getUniformLocation(prog, name);
        });
      } catch (err) {
        gl = null;
        glFailed = true;
      }
    }

    function applyColors() {
      colorBack.set(hexToRgba(config.colorBack));
      for (var i = 0; i < 7; i++) {
        colorFlat.set(hexToRgba(config.colors[Math.min(i, config.colors.length - 1)]), i * 4);
      }
    }

    function sizeCanvas() {
      if (!gl) return;
      lastMeasure = performance.now();
      var rect = canvas.getBoundingClientRect();
      if (!rect.width) return;
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      var w = Math.max(2, Math.round(rect.width * dpr));
      var h = Math.max(2, Math.round(rect.height * dpr));
      if (canvas.width !== w || canvas.height !== h) {
        canvas.width = w;
        canvas.height = h;
      }
    }

    function edgeVertical() {
      var value = config.edgeVertical;
      if (value == null) value = options.edgeVertical;
      if (typeof value === 'function') value = value();
      if (typeof value === 'number' && !isNaN(value)) return value;
      return value ? 1 : 0;
    }

    function render(now) {
      if (!gl) return;
      if (now - lastMeasure > 500) sizeCanvas();
      if (colorsDirty) {
        applyColors();
        colorsDirty = false;
      }
      if (progGrain && !bakeGrain(canvas.width, canvas.height)) fallBackToSinglePass();
      if (!gl) return;
      gl.viewport(0, 0, canvas.width, canvas.height);
      gl.useProgram(prog);
      if (progGrain) {
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, grainTex);
      }
      gl.uniform1f(uniforms.u_time, ((now - t0) / 1000) * config.speed);
      gl.uniform2f(uniforms.u_resolution, canvas.width, canvas.height);
      gl.uniform1f(uniforms.u_softness, config.softness);
      gl.uniform1f(uniforms.u_intensity, config.intensity);
      gl.uniform1f(uniforms.u_noise, config.noise);
      gl.uniform1f(uniforms.u_grainScale, config.grainScale);
      gl.uniform1f(uniforms.u_shape, config.shape);
      gl.uniform1f(uniforms.u_scale, config.scale);
      gl.uniform1f(uniforms.u_rotation, config.rotation);
      gl.uniform1f(uniforms.u_offsetX, config.offsetX);
      gl.uniform1f(uniforms.u_offsetY, config.offsetY);
      gl.uniform1f(uniforms.u_band, config.band);
      gl.uniform1f(uniforms.u_edgeVertical, edgeVertical());
      gl.uniform1f(uniforms.u_colorsCount, Math.min(config.colors.length, 7));
      gl.uniform4fv(uniforms.u_colorBack, colorBack);
      gl.uniform4fv(uniforms.u_colors, colorFlat);
      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    }

    function loop(now) {
      if (Governor.frame(now)) render(now);
      raf = requestAnimationFrame(loop);
    }

    function ensureGL() {
      if (gl) return true;
      if (glFailed) return false;
      glFailed = !initGL();
      return !glFailed;
    }

    return {
      setConfig: function (next) {
        config = Object.assign({}, DEFAULTS, next || {});
        if (!config.colors || !config.colors.length) config.colors = DEFAULTS.colors.slice();
        colorsDirty = true;
      },
      start: function () {
        if (raf || !ensureGL()) return;
        sizeCanvas();
        t0 = t0 || performance.now();
        raf = requestAnimationFrame(loop);
      },
      stop: function () {
        if (!raf) return;
        cancelAnimationFrame(raf);
        raf = 0;
      },
      renderFrame: function () {
        if (!ensureGL()) return;
        t0 = t0 || performance.now();
        lastMeasure = -Infinity;
        render(performance.now());
      },
      resize: sizeCanvas,
      isRunning: function () {
        return !!raf;
      },
    };
  }

  function inViewport(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || 0;
    var vw = window.innerWidth || 0;
    return r.width > 0 && r.height > 0 &&
      r.bottom > -vh * 0.2 && r.top < vh * 1.2 &&
      r.right > 0 && r.left < vw;
  }

  function initFromDocument() {
    var hosts = document.querySelectorAll('[data-grad]');
    if (!hosts.length) return;

    var instances = [];
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasIO = 'IntersectionObserver' in window;

    function ensureShader(inst) {
      if (inst.shader) return inst.shader;
      inst.shader = create(inst.canvas);
      inst.shader.setConfig(configFromElement(inst.host));
      return inst.shader;
    }

    function syncInstance(inst) {
      if (!inst.onScreen || document.hidden) {
        if (inst.shader) inst.shader.stop();
        return;
      }
      var shader = ensureShader(inst);
      if (prefersReducedMotion) shader.renderFrame();
      else {
        shader.renderFrame();
        shader.start();
      }
    }

    hosts.forEach(function (host) {
      var canvas = host.tagName === 'CANVAS' ? host : host.querySelector('canvas');
      if (!canvas) return;
      var inst = { host: host, canvas: canvas, shader: null, onScreen: !hasIO };

      if (hasIO) {
        new IntersectionObserver(function (entries) {
          inst.onScreen = entries[0].isIntersecting;
          syncInstance(inst);
        }, { rootMargin: '20%' }).observe(canvas);
        if (inViewport(canvas)) {
          inst.onScreen = true;
          syncInstance(inst);
        }
      } else {
        syncInstance(inst);
      }

      instances.push(inst);
    });

    function onResize() {
      instances.forEach(function (inst) {
        if (!inst.shader) return;
        inst.shader.resize();
        if (prefersReducedMotion) inst.shader.renderFrame();
      });
    }

    window.addEventListener('resize', onResize);
    document.addEventListener('visibilitychange', function () {
      instances.forEach(syncInstance);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFromDocument);
  } else {
    initFromDocument();
  }

  window.GradShader = {
    create: create,
    configFor: configFor,
    configFromElement: configFromElement,
    hexToRgba: hexToRgba,
    DEFAULTS: DEFAULTS,
    PRODUCT_GRAD: PRODUCT_GRAD,
  };
})();
